import { render, staticRenderFns } from "./StatusQuotations.vue?vue&type=template&id=40e10ad9&scoped=true"
import script from "./StatusQuotations.vue?vue&type=script&lang=js"
export * from "./StatusQuotations.vue?vue&type=script&lang=js"
import style0 from "./StatusQuotations.vue?vue&type=style&index=0&id=40e10ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e10ad9",
  null
  
)

export default component.exports